var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "comment-block",
      class: {
        "first-level": !_vm.parent,
        editing: _vm.editing,
      },
      attrs: { "data-comment": _vm.comment.id },
    },
    [
      _vm.visible
        ? [
            _c(
              "div",
              { staticClass: "content" },
              [
                _vm.editing
                  ? [
                      _c("comment-form", {
                        attrs: {
                          active: true,
                          comment: _vm.comment,
                          pending: _vm.updating,
                          parent: _vm.parent,
                        },
                        on: { submitted: _vm.update },
                      }),
                    ]
                  : _vm._e(),
                _c("comment-content", {
                  staticClass: "comment-content",
                  attrs: {
                    comment: _vm.comment,
                    "can-restore": _vm.canRestore,
                    "can-reply": _vm.canEdit,
                    "can-edit": _vm.canEdit,
                  },
                  on: {
                    remove: _vm.remove,
                    restore: _vm.restore,
                    edit: _vm.edit,
                    reply: _vm.reply,
                  },
                }),
              ],
              2
            ),
            _vm.comment.answers && _vm.comment.answers.length
              ? _c(
                  "div",
                  { staticClass: "answers" },
                  _vm._l(_vm.comment.answers, function (answer) {
                    return _c(
                      "div",
                      { key: answer.id },
                      [
                        _c("conversation-comment", {
                          attrs: {
                            entity: _vm.entity,
                            "entity-id": _vm.entityId,
                            comment: answer,
                            "can-edit": _vm.canEdit,
                            parent: _vm.comment,
                            "active-form": _vm.activeForm,
                          },
                          on: {
                            formOpened: function ($event) {
                              return _vm.$emit("formOpened", $event)
                            },
                            commentAdded: function ($event) {
                              return _vm.$emit("commentAdded", $event)
                            },
                            commentUpdated: function ($event) {
                              return _vm.$emit("commentUpdated", $event)
                            },
                            commentRemoved: function ($event) {
                              return _vm.$emit("commentRemoved", $event)
                            },
                            commentRestored: function ($event) {
                              return _vm.$emit("commentRestored", $event)
                            },
                          },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                )
              : _vm._e(),
            _vm.replying
              ? [
                  _c(
                    "div",
                    { staticClass: "reply-form" },
                    [
                      _c("comment-form", {
                        attrs: {
                          active: true,
                          parent: _vm.parent,
                          pending: _vm.updating,
                        },
                        on: { submitted: _vm.addAnswer },
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }